import PaymentMethodSwitcher from './PaymentMethodSwitcher'

export default PaymentMethodSwitcher
